import React, { useState } from 'react';
import "../../Styles/yellocalfcss/SpecialFees.css";

const GenerateSpecialInvoice = () => {
  const [formData, setFormData] = useState({
    student: '',
    feeCategory: '',
    term: '',
    amount: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.student.trim()) {
      newErrors.student = 'Student cannot be blank.';
    }

    if (!formData.feeCategory) {
      newErrors.feeCategory = 'Fee Category is required.';
    }

    if (!formData.term) {
      newErrors.term = 'Terms/Semester is required.';
    }

    if (!formData.amount) {
      newErrors.amount = 'Amount is required.';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log('Form Submitted:', formData);
      alert('Invoice created successfully!');
      setFormData({
        student: '',
        feeCategory: '',
        term: '',
        amount: '',
      });
    }
  };

  return (
    <div className="container-fluid SpecialFees-invoice-container my-3">
      <div className="SelectStudent-invoice-header">
        <h4>Generate Special Invoice</h4>
      </div>

      <form onSubmit={handleSubmit} className="SpecialFees-invoice-form">
        <div className="row mb-3">
          <div className="col-md-6 col-12">
            <div className="mb-3">
              <label htmlFor="student" className="form-label">
                Students <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="student"
                className={`form-control ${errors.student ? 'is-invalid' : ''}`}
                value={formData.student}
                onChange={handleChange}
              />
              {errors.student && (
                <div className="invalid-feedback">{errors.student}</div>
              )}
            </div>
          </div>

          <div className="col-md-6 col-12">
            <div className="mb-3">
              <label htmlFor="feeCategory" className="form-label">
                Fee Category <span className="text-danger">*</span>
              </label>
              <select
                id="feeCategory"
                className={`form-select ${errors.feeCategory ? 'is-invalid' : ''}`}
                value={formData.feeCategory}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="tuition">Fine</option>
                <option value="library">Penalty</option>
                <option value="tuition">Medical Reimbursement</option>
                <option value="library">Library</option>
                <option value="library">Trrtt</option>
              </select>
              {errors.feeCategory && (
                <div className="invalid-feedback">{errors.feeCategory}</div>
              )}
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6 col-12">
            <div className="mb-3">
              <label htmlFor="term" className="form-label">
                Terms/Semester <span className="text-danger">*</span>
              </label>
              <select
                id="term"
                className={`form-select ${errors.term ? 'is-invalid' : ''}`}
                value={formData.term}
                onChange={handleChange}
              >
                <option value=""></option>
                <option value="tuition">Sem-I</option>
                <option value="library">Sem-II</option>
              </select>
              {errors.term && (
                <div className="invalid-feedback">{errors.term}</div>
              )}
            </div>
          </div>

          <div className="col-md-6 col-12">
            <div className="mb-3">
              <label htmlFor="amount" className="form-label">
                Amount($) <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                id="amount"
                className={`form-control ${errors.amount ? 'is-invalid' : ''}`}
                value={formData.amount}
                onChange={handleChange}
              />
              {errors.amount && (
                <div className="invalid-feedback">{errors.amount}</div>
              )}
            </div>
          </div>
        </div>

        <div className=" d-flex justify-content-end">
          <button
            type="submit"
            className="btn custom-btn d-flex justify-content-right"
          >
            Create
          </button>
        </div>
      </form>
    </div>
  );
};

export default GenerateSpecialInvoice;
